import { render, staticRenderFns } from "./CommonCodeAttrbPopup.vue?vue&type=template&id=4f6bc142&"
import script from "./CommonCodeAttrbPopup.vue?vue&type=script&lang=js&"
export * from "./CommonCodeAttrbPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports